import { BankIdLoginContainer } from '../../containers/bank-id-login-container';
import { UsernameLoginContainer } from '../../containers/username-login-container';
import { WelcomeBackground } from '../welcome-background';
import './styles.less';
const {
  RedirectToReturnUrl
} = svs.retailUtils;
const {
  NavLink,
  Redirect,
  Route,
  Switch,
  useHistory
} = ReactRouterDOM;
const {
  Dialog
} = svs.retailUi;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
export const Login = ({
  error,
  hasToChangePassword,
  hasMissingUserMetadata,
  isComplete,
  onCloseErrorDialog,
  onCloseMetadataErrorDialog
}) => {
  const history = useHistory();
  const isIamIdpModule = svs.core?.data?.module === 'iam-idp';
  const loginBasePath = isIamIdpModule ? '' : '/logga-in';
  const bankIdPath = `${loginBasePath}/bank-id`;
  const usernamePath = `${loginBasePath}/anvandarnamn`;
  const bankIdPaths = isIamIdpModule ? ['/bank-id', '/logga-in/bank-id'] : [bankIdPath];
  const usernamePaths = isIamIdpModule ? ['/anvandarnamn', '/logga-in/anvandarnamn'] : [usernamePath];
  const bankIdTarget = `${bankIdPath}${history.location.search}`;
  const usernameTarget = `${usernamePath}${history.location.search}`;
  return <WelcomeBackground className="login-component padding-top-2 padding-bottom-4" isDark>
      {isComplete && !hasToChangePassword && <RedirectToReturnUrl />}
      {!isComplete && hasMissingUserMetadata && <Dialog buttonCallback={onCloseMetadataErrorDialog} buttonTitle="Okej" icon="exclamation-sign" message="Det gick inte att hämta all information om ditt konto. Viss funktionalitet kommer inte vara tillgänglig." title="Någonting gick fel" />}

      {error && <Dialog buttonCallback={onCloseErrorDialog} buttonTitle="Okej" icon={error.icon} message={error.message} severe={error.severe} title={error.title} type={error.type} />}

      <ItemsMenu centered>
        <LinkItem activeClassName="login-menu-active" Component={NavLink} label="Bank-id" to={bankIdTarget} />
        <LinkItem activeClassName="login-menu-active" Component={NavLink} label="Användarnamn" to={usernameTarget} />
      </ItemsMenu>

      <Switch>
        <Route component={BankIdLoginContainer} path={bankIdPaths} />
        <Route component={UsernameLoginContainer} path={usernamePaths} />
        <Redirect to={{
        pathname: bankIdPath,
        search: window.location.search
      }} />
      </Switch>
    </WelcomeBackground>;
};